import { DayOfWeek } from 'generated/graphql-types';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { DayOfWeekOption } from '../models/day-of-week-option';
import { dayOfWeekOptionActions } from './day-of-week-option.actions';

export const dayOfWeekOptionFeatureKey = 'dayOfWeekOptions';

export type DayOfWeekOptionState = EagerSelectState<DayOfWeekOption>;

const adapter = createEagerSelectAdapter<DayOfWeekOptionState, DayOfWeekOption>({
   featureKey: dayOfWeekOptionFeatureKey,
   selectId: (dayOfWeek: DayOfWeekOption) => {
      return dayOfWeek.dayOfWeek ? dayOfWeek.dayOfWeek : '';
   },
});

export const dayOfWeekOptionSelectors = adapter.getSelectors(filterDayOfWeekNameOption);

const initialState = adapter.getInitialState();

export const dayOfWeekOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   dayOfWeekOptionActions.search,
   dayOfWeekOptionActions.searchReset,
   dayOfWeekOptionActions.loadFromApi,
   dayOfWeekOptionActions.loadFromApiSuccess,
   dayOfWeekOptionActions.loadFromApiFailure
);

export function filterDayOfWeekNameOption<T extends DayOfWeekOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.values(DayOfWeek)
      .filter((dayOfWeek) => {
         if (searchText) {
            return dayOfWeek.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((dayOfWeek) => {
         return { dayOfWeek } as T;
      });

   return filteredOptions;
}
